module.exports = __webpack_public_path__ + "static/map@2x-7f7bd541e31ea32ab1607e29580c4012.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/map@2x.png
// module id = 2614
// module chunks = 168707334958949